import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_CUSTOMERS } from "../../../utils/constants";
import { CustomerInterface } from "../../../models/TicketModule/Customer";
import customerService from "../../../services/ticketService/customerService";

interface AddCustomersContext {
  previousCustomers: CustomerInterface[];
}

const useAddCustomers = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<
    CustomerInterface,
    Error,
    CustomerInterface,
    AddCustomersContext
  >({
    mutationFn: customerService.Save,

    onMutate: () => {
      const previousCustomers =
        queryClient.getQueryData<CustomerInterface[]>([
          CACHE_KEY_CUSTOMERS,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ]) || [];

      return { previousCustomers };
    },

    onSuccess: (savedCustomer) => {
      queryClient.setQueryData<CustomerInterface[]>(
        [
          CACHE_KEY_CUSTOMERS,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ],
        (customers) =>
          customers ? [savedCustomer, ...customers] : [savedCustomer]
      );
    },

    onError: (error, newCustomer, context) => {
      if (!context) return;

      queryClient.setQueryData<CustomerInterface[]>(
        [
          CACHE_KEY_CUSTOMERS,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ],
        context.previousCustomers
      );
    },
  });
};

export default useAddCustomers;
